import React from 'react';
import { Card } from '@usealloy/component-library';

import ReturnedReasonCodes from '~/entities/evaluations/ReturnedReasonCodes';

import { useEventTypeEvaluationsContext } from '../context';

const ReasonCodes: React.FC = () => {
  const { evaluation } = useEventTypeEvaluationsContext();

  const isWorkflowTypeJourneyRouter = evaluation.evaluation_type === 'journey_router';
  const isWorkflowTypeReconciliation = evaluation.evaluation_type === 'reconciliation';

  const shouldShowReasonCodes = !isWorkflowTypeJourneyRouter && !isWorkflowTypeReconciliation;

  if (!shouldShowReasonCodes) {
    return null;
  }
  return (
    <Card
      header="Returned Reason Codes"
      collapsible
      data-testId="new-returned-reason-codes"
      id="reason-codes-product-announcement"
    >
      <ReturnedReasonCodes
        extraneousReasonCodeResults={evaluation.extraneous_reason_code_results}
        taggedReasonCodeResults={evaluation.tagged_reason_code_results}
        untaggedReasonCodeResults={evaluation.untagged_reason_code_results}
        returnedTags={(evaluation.tags || []).filter(t => !t.is_outcome_reason)}
      />
    </Card>
  );
};

export default ReasonCodes;
